'use client';

import React from 'react';
import {
  RoomAudioRenderer,
  useConnectionState,
} from '@livekit/components-react';
import { ConnectionState } from 'livekit-client';
import '@livekit/components-styles';
import { Button } from '@components/common/Forms/Button/Button';
import { useTranslation } from 'next-i18next';
import { cn } from '@root/src/utils/cn';
import { PulsatingBestieAvatar } from './partials/PulsatingBestieAvatar';

const AudioInterviewRoomContent: React.FC<{
  onDisconnect: () => void;
}> = ({ onDisconnect }) => {
  const { t } = useTranslation('common');
  const connectionState = useConnectionState();

  let connectionStatusText = '';
  if (connectionState === ConnectionState.Connecting) {
    connectionStatusText = t('audio-interview.connecting');
  } else if (connectionState === ConnectionState.Connected) {
    connectionStatusText = t('audio-interview.connected');
  }

  return (
    <div className="flex min-h-[600px] flex-col">
      {/* Header */}
      <div className="mb-8 text-center">
        <h2 className="mb-2 text-2xl font-bold text-ink">
          {t('audio-interview.title')}
        </h2>
        <div className="flex items-center justify-center space-x-2">
          <div className={cn('size-2 rounded-full', connectionState === ConnectionState.Connected ? 'bg-secondary' : 'bg-ink-light')} />
          <span className="text-sm text-ink-light">
            {connectionStatusText}
          </span>
        </div>
      </div>

      {/* Main Content - Centered Bestie */}
      <div className="flex flex-1 flex-col items-center justify-center">
        <PulsatingBestieAvatar
          isConnected={connectionState === ConnectionState.Connected}
        />
      </div>

      {/* Footer Controls */}
      <div className="mt-12 flex flex-col items-center space-y-4">
        <div className="flex items-center space-x-4">
          <Button
            type="button"
            styling="outline"
            color="error"
            size="md"
            rounding="normal"
            onClick={onDisconnect}
            className="min-w-32"
          >
            {t('audio-interview.exit-interview')}
          </Button>
        </div>
      </div>

      {/* Hidden Audio Renderer */}
      <RoomAudioRenderer />
    </div>
  );
};

export default AudioInterviewRoomContent;
